import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '../views/HomeView.vue';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/news/news.vue'),
  },
  {
    path: '/newsDetail',
    name: 'NewsDetail',
    component: () => import('../views/news/newsDetail.vue'),
  },
  {
    path: '/notice',
    name: 'Notice',
    component: () => import('../views/news/notice.vue'),
  },
  // 主席团
  {
    path: '/presidium',
    name: 'Presidium',
    component: () => import('../views/dramaFestival/presidium.vue'),
  },
  {
    path: '/presidiumDetail',
    name: 'PresidiumDetail',
    component: () => import('../views/dramaFestival/presidiumDetail.vue'),
  },
  {
    path: '/Introduction',
    name: 'Introduction',
    component: () => import('../views/dramaFestival/Introduction.vue'),
  },
  // 委员会
  {
    path: '/ArtCommittee',
    name: 'ArtCommittee',
    component: () => import('../views/dramaFestival/ArtCommittee.vue'),
  },
  {
    path: '/JudgingCommittee',
    name: 'JudgingCommittee',
    component: () => import('../views/dramaFestival/JudgingCommittee.vue'),
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: () => import('../views/aboutUs/contactUs.vue'),
  },
  {
    path: '/supportUs',
    name: 'SupportUs',
    component: () => import('../views/aboutUs/supportUs.vue'),
  },
  {
    path: '/videoList',
    name: 'VideoList',
    component: () => import('../views/video/videoList.vue'),
  },
  {
    path: '/theme',
    name: 'Theme',
    component: () => import('../views/theme/theme.vue'),
  },
  {
    path: '/themeTime',
    name: 'ThemeTime',
    component: () => import('../views/theme/themeTime.vue'),
  },
  // 特邀剧目
  {
    path: '/invitedPlay',
    name: 'InvitedPlay',
    component: () => import('../views/theme/invitedPlay.vue'),
  },
  // 特邀剧目详情
  {
    path: '/invitedPlayDetail',
    name: 'InvitedPlayDetail',
    component: () => import('../views/theme/invitedPlayDetail.vue'),
  },
  // 章程
  {
    path: '/articleRules',
    name: 'ArticleRules',
    component: () => import('../views/theme/articleRules.vue'),
  },
  // 戏剧集市
  {
    path: '/themeMarket',
    name: 'ThemeMarket',
    component: () => import('../views/themeMarket/themeMarket.vue'),
  },
  // 戏剧空间
  {
    path: '/dramaSpace',
    name: 'DramaSpace',
    component: () => import('../views/dramaSpace/dramaSpace.vue'),
  },
  //青年竞演
  {
    path: '/youthCompeti',
    name: 'YouthCompeti',
    component: () => import('../views/youthCompeti/youthCompeti.vue'),
  },
  //古镇嘉年华
  {
    path: '/Carnival',
    name: 'Carnival',
    component: () => import('../views/Carnival/Carnival.vue'),
  },
  //小镇对话
  {
    path: '/townDialogue',
    name: 'TownDialogue',
    component: () => import('../views/townDialogue/townDialogue.vue'),
  },
  //戏梦粮仓
  {
    path: '/dreamDrama',
    name: 'DreamDrama',
    component: () => import('../views/dreamDrama/dreamDrama.vue'),
  },
  //戏梦粮仓
  {
    path: '/dreamDramaDetail',
    name: 'DreamDramaDetail',
    component: () => import('../views/dreamDrama/dreamDramaDetail.vue'),
  },
  //戏剧活动详情
  {
    path: '/dramaActivityDetail',
    name: 'DramaActivityDetail',
    component: () => import('../views/dreamDrama/dramaActivityDetail.vue'),
  },
  // 地图
  {
    path: '/map',
    name: 'Map',
    component: () => import('../views/knowMore/map.vue'),
  },
  // 地图
  {
    path: '/memento',
    name: 'Memento',
    component: () => import('../views/knowMore/memento.vue'),
  },
  // 常见问题
  {
    path: '/commonProblem',
    name: 'CommonProblem',
    component: () => import('../views/knowMore/commonProblem.vue'),
  },
  //剧场
  {
    path: '/theater',
    name: 'Theater',
    component: () => import('../views/knowMore/theater.vue'),
  },
  //剧场详情
  {
    path: '/theaterDetail',
    name: 'TheaterDetail',
    component: () => import('../views/knowMore/theaterDetail.vue'),
  },
  // 交通指南
  {
    path: '/transGuide',
    name: 'TransGuide',
    component: () => import('../views/knowMore/transGuide.vue'),
  },
  //住宿指南
  {
    path: '/hotelGuide',
    name: 'HotelGuide',
    component: () => import('../views/knowMore/hotelGuide.vue'),
  },
  // 媒体注册
  {
    path: '/mediaRegist',
    name: 'MediaRegist',
    component: () => import('../views/mediaRegist/mediaRegist.vue'),
  },
  // 全站搜索
  {
    path: '/fullSearch',
    name: 'FullSearch',
    component: () => import('../views/fullSearch/fullSearch.vue'),
  },
  // 合作伙伴
  {
    path: '/partner',
    name: 'Partner',
    component: () => import('../views/partner/partner.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  // mode: 'hash', // 改为 hash 模式
  base: process.env.BASE_URL,
  routes,
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') throw err;
  });
};
export default router;
